import { useDispatch } from 'react-redux';
import { BannerInstagramWithLoader } from './loaders';

export const BannerInstagram = () => {
    const dispatch = useDispatch();

    return <BannerInstagramWithLoader />;
};
